export const returnDisplay = (value, optionsArray) =>
  Array.isArray(optionsArray) ? value : optionsArray[value];
